const languages = [
  {
    name: 'हिंदी',
    alternate_name: 'Hindi',
    background: 'bg-olivine-20',
    color: 'text-olivine-170',
    locale: 'hi',
  },
  {
    name: 'English',
    alternate_name: 'अंग्रेज़ी',
    background: 'bg-neutral-20',
    color: 'text-neutral-100',
    locale: 'en',
  },
  {
    name: 'বাংলা ',
    alternate_name: 'Bangla',
    background: 'bg-secondary-one-30',
    color: 'text-error-110',
    locale: 'bn',
  },
  {
    name: 'मराठी ',
    alternate_name: 'Marathi',
    background: 'bg-warning-10',
    color: 'text-secondary-two-120',
    locale: 'mr',
  },
  {
    name: 'ઓડિયા',
    alternate_name: 'Odia',
    background: 'bg-error-10',
    color: 'text-error-180',
    locale: 'or',
  },
  {
    name: 'ગુજરાતી',
    alternate_name: 'Gujarati',
    background: 'bg-french-blue-10',
    color: 'text-french-blue-180',
    locale: 'gu',
  },
]

export default languages
